module.exports = __webpack_public_path__ + "img/icon-return.608e6048.png";